export default __webpack_public_path__ + "static/media/con_vitaminas.9c4c2bd7.svg";